module.exports = __webpack_public_path__ + "static/media/contact1.c906cc30.jpg";